export default __webpack_public_path__ + "static/media/menu-logo.ea736f93.svg";